import React, { useState, useEffect } from 'react';
import stories from './science.json';
import './Story.css';

function ScienceBasics() {
  const [selectedId, setSelectedId] = useState('');
  const story = stories.find(s => s.id === selectedId);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    const voice = voices.find(v => v.lang === langCode);

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;

    synth.speak(utterance);
  };

  return (
    <div className="app">
      <h1>🔬 Science Basics</h1>
      <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
        <option value="">Select a science topic</option>
        {stories.map(s => (
          <option key={s.id} value={s.id}>{s.title}</option>
        ))}
      </select>

      {story && (
        <div className="story-container">
          {/* English */}
          {story.english && (
            <div className="language-block">
              <h2>{story.title}</h2>
              {story.english.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <h3>{story.english.moralHeading}</h3>
              <p>{story.english.moral}</p>
              <button onClick={() => speak([...story.english.lines, story.english.moral].join(' '), 'en-US')}>
                🔊 Read Aloud (English)
              </button>
            </div>
          )}

          {/* Hindi */}
          {story.hindi && (
            <div className="language-block">
              <h2>{story.hindi.title}</h2>
              {story.hindi.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <h3>{story.hindi.moralHeading}</h3>
              <p>{story.hindi.moral}</p>
              <button onClick={() => speak([...story.hindi.lines, story.hindi.moral].join(' '), 'hi-IN')}>
                🔊 Read Aloud (Hindi)
              </button>
            </div>
          )}

          {/* Telugu */}
          {story.telugu && (
            <div className="language-block">
              <h2>{story.telugu.title}</h2>
              {story.telugu.lines?.map((line, i) => <p key={i}>{line}</p>)}
              <h3>{story.telugu.moralHeading}</h3>
              <p>{story.telugu.moral}</p>
              <button onClick={() => speak([...story.telugu.lines, story.telugu.moral].join(' '), 'te-IN')}>
                🔊 Read Aloud (Telugu)
              </button>
            </div>
          )}
             {/* Tamil */}
          {story.tamil && (
         <div className="language-block">
            <h2>{story.tamil.title}</h2>
            {story.tamil.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.tamil.moralHeading}</h3>
            <p>{story.tamil.moral}</p>
            <button onClick={() => speak([...story.tamil.lines, story.tamil.moral].join(' '), 'ta-IN')}>🔊 Read Aloud (Tamil)</button>
          </div>
          )}
           {/* spanish */}
          {story.spanish && (
      <div className="language-block">
            <h2>{story.spanish.title}</h2>
            {story.spanish.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.spanish.moralHeading}</h3>
            <p>{story.spanish.moral}</p>
            <button onClick={() => speak([...story.spanish.lines, story.spanish.moral].join(' '), 'es-ES')}>🔊 Read Aloud (Spanish)</button>
          </div>
          )}
   {/* French */}
          {story.french && (
       <div className="language-block">
            <h2>{story.french.title}</h2>
            {story.french.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.french.moralHeading}</h3>
            <p>{story.french.moral}</p>
            <button onClick={() => speak([...story.french.lines, story.french.moral].join(' '), 'fr-FR')}>🔊 Read Aloud (French)</button>
          </div>
          )}

   {/* Mandarin */}
          {story.mandarin && (
       <div className="language-block">
            <h2>{story.mandarin.title}</h2>
            {story.mandarin.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.mandarin.moralHeading}</h3>
            <p>{story.mandarin.moral}</p>
            <button onClick={() => speak([...story.mandarin.lines, story.mandarin.moral].join(' '), 'zh-CN')}>🔊 Read Aloud (Mandarin)</button>
          </div>
          )}

            {/* Russian */}
          {story.russian && (
        <div className="language-block">
            <h2>{story.russian.title}</h2>
            {story.russian.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.russian.moralHeading}</h3>
            <p>{story.russian.moral}</p>
            <button onClick={() => speak([...story.russian.lines, story.russian.moral].join(' '), 'ru-RU')}>🔊 Read Aloud (Russian)</button>
          </div>
          )}

             {/* Japanese */}
          {story.japanese && (
         <div className="language-block">
            <h2>{story.japanese.title}</h2>
            {story.japanese.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.japanese.moralHeading}</h3>
            <p>{story.japanese.moral}</p>
            <button onClick={() => speak([...story.japanese.lines, story.japanese.moral].join(' '), 'ja-JP')}>🔊 Read Aloud (Japanese)</button>
          </div>
        
          )}

          {/* Repeat same pattern for Tamil, Spanish, French, Mandarin, Russian, Japanese */}
        </div>
      )}
    </div>
  );
}

export default ScienceBasics;


     